
import Vue from 'vue'
import PageTitle from '@/components/PageTitle.vue'
import AdministrationBreadcrumb from './AdministrationBreadcrumb.vue'

export default Vue.extend({
   name: 'AdministrationPageHeader',
   props: {
      crumbs: { type: Array as () => Breadcrumb[], default: () => [] },
      title: { type: String, default: '' },
   },
   computed: {
      pageTitle(): string {
         if (this.title.length > 0) {
            return this.title
         }
         const lastCrumb = this.crumbs.last
         return lastCrumb ? lastCrumb.text : ''
      },
   },
   components: {
      PageTitle,
      AdministrationBreadcrumb,
   },
})
